// @flow
/*eslint-disable sort-keys */
import { itemSortOrders } from './';

const savedSearchItemSortOrders = {
    ...itemSortOrders,
    RESULT_RECENT_FIRST: 'RESULT_RECENT_FIRST',
    RESULT_OLDEST_FIRST: 'RESULT_OLDEST_FIRST',
};

export default savedSearchItemSortOrders;
